























import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Logo extends Vue {
  @Prop({ type: [String, Number ], required: true }) private width!: string | number;
  @Prop({ type: [String, Number ], required: true }) private height!: string | number;
  @Prop({ type: Boolean, required: false, default: true }) private clickable!: boolean;
}
